(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25945],{

/***/ 43274:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkHBRSM4ERjs = __webpack_require__(57777);var _react = __webpack_require__(67294); var _react2 = _interopRequireDefault(_react);var _styled = __webpack_require__(95934); var _styled2 = _interopRequireDefault(_styled);var _react3 = __webpack_require__(70917);var _jsxruntime = __webpack_require__(85893);function v({children:e}){return e}var x=(e,t)=>e==="large"?t.measurements.spacing(7):t.measurements.spacing(6),I=(e,t)=>e==="large"?t.measurements.spacing(10):t.measurements.spacing(8),m=_react3.css`
  display: inline-flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
`,_=_styled2.default.span`
  display: inline-flex;
  align-items: center;
`,F=_styled2.default.call(void 0, _chunkHBRSM4ERjs.a)`
  margin-top: ${e=>e.theme.measurements.spacing(.5)};
  margin-left: ${e=>e.theme.measurements.spacing(.25)};
  display: inline-block;
  transition: 0.35s;

  .arrow-line,
  .arrow-pointer {
    transition: 0.35s;
    fill: ${e=>e.theme.palette.BASE_FILL};
  }
`,T=_styled2.default.a`
  ${m}
  color: ${e=>e.theme.palette.BASE_FILL};
  text-decoration: ${e=>e.$underline?"underline":"none"};
  text-decoration-color: ${e=>e.$underline?e.theme.palette.BASE_FILL:"transparent"};
  font-size: ${e=>x(e.$size,e.theme)};
  line-height: ${e=>I(e.$size,e.theme)};
  font-weight: 600;
  pointer-events: ${e=>e.$disabled?"none":"auto"};
  cursor: ${e=>e.$disabled?"not-allowed":"pointer"};

  &:active,
  &:focus {
    color: ${e=>e.theme.palette.PRIMARY_FOCUS};
    text-decoration-color: ${e=>e.theme.palette.PRIMARY_FOCUS};

    .arrow-line,
    .arrow-pointer {
      fill: ${e=>e.theme.palette.PRIMARY_FOCUS};
    }
  }

  :hover {
    svg.anchor-arrow {
      margin-left: ${e=>e.theme.measurements.spacing(3.25)};
    }

    path.arrow-line {
      d: path(
        'M0.5 5.5C0.5 5.08579 0.787817 4.75 1.14286 4.75H8.85714C9.21218 4.75 9.5 5.08579 9.5 5.5C9.5 5.91421 9.21218 6.25 8.85714 6.25H1.14286C0.787817 6.25 0.5 5.91421 0.5 5.5Z'
      );
    }
  }
`,M=_styled2.default.a`
  ${m}
  color: ${e=>e.theme.palette.BASE_FILL};
  font-size: ${e=>e.theme.measurements.spacing(6)};
  font-weight: 700;
  line-height: ${e=>e.theme.measurements.spacing(7)};
  text-transform: uppercase;
  background: ${e=>e.theme.palette.BASE_ONE};
  border: ${e=>e.theme.measurements.shape(.25)} solid
    ${e=>e.theme.palette.DIVIDER};
  border-radius: ${e=>e.theme.measurements.shape(1.5)};
  padding: ${e=>e.theme.measurements.spacing(e.$size==="small"?4.5:6)}
    ${e=>e.theme.measurements.spacing(e.$size==="small"?6:9)};
  pointer-events: ${e=>e.$disabled?"none":"auto"};
  cursor: ${e=>e.$disabled?"not-allowed":"pointer"};

  &:hover {
    background: ${e=>e.theme.palette.BASE_ZERO};
  }

  &:active,
  &:focus {
    background: ${e=>e.theme.palette.DIVIDER};
  }
`,H=_react2.default.forwardRef((e,t)=>{let{href:s,as:d,Wrapper:h=v,newTab:p=!1,children:$,ariaLabel:u,title:g,onClick:n,dataTestId:f,className:b,disabled:a,rightArrow:l=!1,underline:A=!0,size:L="large",variant:i="primary",rel:k="noopener noreferrer"}=e,w=p?"_blank":"_self",S=i==="caps"?M:T,R=_react.useCallback.call(void 0, C=>{!n||n(C)},[n]);return _jsxruntime.jsx.call(void 0, h,{href:s,as:d,disabled:a,children:_jsxruntime.jsxs.call(void 0, S,{href:s,target:w,ref:t,title:g,"aria-label":u,"data-testid":f,onClick:!a&&n?R:void 0,className:b,$disabled:a,$underline:A&&!l,$variant:i,$size:L,rel:k,children:[_jsxruntime.jsx.call(void 0, _,{children:$}),l&&i!=="caps"?_jsxruntime.jsx.call(void 0, F,{}):""]})})}),W= exports.a =H;exports.a = W;


/***/ }),

/***/ 57777:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));var _jsxruntime = __webpack_require__(85893);function o({className:l}){return _jsxruntime.jsxs.call(void 0, "svg",{width:"11",height:"11",viewBox:"0 0 11 11",fill:"none",xmlns:"http://www.w3.org/2000/svg",className:`anchor-arrow ${l}`,children:[_jsxruntime.jsx.call(void 0, "path",{fillRule:"evenodd",clipRule:"evenodd",d:"M4.98298 0.731232C5.29363 0.422923 5.79728 0.422923 6.10793 0.731232L10.3503 4.94176C10.661 5.25007 10.661 5.74993 10.3503 6.05824L6.10793 10.2688C5.79728 10.5771 5.29363 10.5771 4.98298 10.2688C4.67234 9.96046 4.67234 9.46059 4.98298 9.15228L8.66294 5.5L4.98298 1.84772C4.67234 1.53941 4.67234 1.03954 4.98298 0.731232Z",fill:"#1E2429",className:"arrow-pointer"}),_jsxruntime.jsx.call(void 0, "path",{fillRule:"evenodd",clipRule:"evenodd",fill:"#1E2429",className:"arrow-line"})]})}var i=o;exports.a = i;


/***/ }),

/***/ 82838:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true})); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }var _chunkXC6L7SUYjs = __webpack_require__(44759);var _react = __webpack_require__(67294); var e = _interopRequireWildcard(_react);var _jsxruntime = __webpack_require__(85893);var t=e.forwardRef((n,d)=>{let{className:i,color:a,height:c=24,width:s=24}=n;return _jsxruntime.jsxs.call(void 0, _chunkXC6L7SUYjs.b,{className:i,ref:d,width:s,height:c,color:a,viewBox:"0 0 24 24",children:[_jsxruntime.jsx.call(void 0, "path",{fillRule:"evenodd",clipRule:"evenodd",d:"M10.0479 14.2293C8.87792 13.0593 7.99592 11.7493 7.40992 10.4203C7.28592 10.1393 7.35892 9.81032 7.57592 9.59332L8.39492 8.77432C9.06592 8.10332 9.06592 7.15432 8.47992 6.56832L7.30592 5.39532C6.52492 4.61432 5.25892 4.61432 4.47792 5.39532L3.82592 6.04632C3.08492 6.78732 2.77592 7.85632 2.97592 8.91632C3.46992 11.5293 4.98792 14.3903 7.43692 16.8393C9.88592 19.2883 12.7469 20.8063 15.3599 21.3003C16.4199 21.5003 17.4889 21.1913 18.2299 20.4503L18.8809 19.7993C19.6619 19.0183 19.6619 17.7523 18.8809 16.9713L17.7079 15.7983C17.1219 15.2123 16.1719 15.2123 15.5869 15.7983L14.6839 16.7023C14.4669 16.9193 14.1379 16.9923 13.8569 16.8683C12.5279 16.2813 11.2179 15.3983 10.0479 14.2293Z",stroke:"currentcolor",strokeWidth:"1.125",strokeLinecap:"round",strokeLinejoin:"round"}),_jsxruntime.jsx.call(void 0, "path",{d:"M12.9198 5.53043V3.19043",stroke:"currentcolor",strokeWidth:"1.125",strokeLinecap:"round",strokeLinejoin:"round"}),_jsxruntime.jsx.call(void 0, "path",{d:"M17.0897 7.18053L18.7397 5.54053",stroke:"currentcolor",strokeWidth:"1.125",strokeLinecap:"round",strokeLinejoin:"round"}),_jsxruntime.jsx.call(void 0, "path",{d:"M18.7499 11.3604H21.0799",stroke:"currentcolor",strokeWidth:"1.125",strokeLinecap:"round",strokeLinejoin:"round"})]})});t.displayName="Call";var u=t;exports.a = t; exports.b = u;


/***/ }),

/***/ 381:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value: true}));var _chunkEIPAFUIYjs = __webpack_require__(43274);var t=_chunkEIPAFUIYjs.a;exports.a = t;


/***/ }),

/***/ 51513:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true});var _chunkMQ5AGG7Cjs = __webpack_require__(74623);__webpack_require__(42310);__webpack_require__(37186);__webpack_unused_export__ = _chunkMQ5AGG7Cjs.a; exports.ZP = _chunkMQ5AGG7Cjs.b;


/***/ }),

/***/ 92378:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true});var _chunkK4V26XJ3js = __webpack_require__(97269);__webpack_require__(93711);var _chunkFXB523TMjs = __webpack_require__(55429);__webpack_require__(37186);exports.F8 = _chunkFXB523TMjs.a; exports.ZP = _chunkK4V26XJ3js.a;


/***/ }),

/***/ 77487:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true});var _chunkKXD6FNLZjs = __webpack_require__(381);__webpack_require__(43274);__webpack_require__(57777);__webpack_require__(37186);exports.Z = _chunkKXD6FNLZjs.a;


/***/ }),

/***/ 56074:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value: true});var _chunkJBZUYSLPjs = __webpack_require__(82838);__webpack_require__(44759);__webpack_require__(42310);__webpack_require__(37186);__webpack_unused_export__ = _chunkJBZUYSLPjs.a; exports.ZP = _chunkJBZUYSLPjs.b;


/***/ }),

/***/ 10428:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/classes",
      function () {
        return __webpack_require__(88678);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getUserModel; },
/* harmony export */   "P": function() { return /* binding */ getFullName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31309);



var getFullName = function(firstName, lastName) {
    return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(firstName), " ").concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_0__/* .capitalize */ .kC)(lastName));
};
var getUserModel = function() {
    var user = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, user), {
        description: user.bio || null,
        thumbnail: user.avatarV1 || user.avatar || null,
        liveMinutes: user.liveMinutes ? Math.round(user.liveMinutes / 60) : 0,
        totalWatchMins: user.totalWatchTime ? Math.round(user.totalWatchTime / 60) : 0,
        name: getFullName(user.firstName, user.lastName),
        newEducatorAvatar: user.avatarV1Web || null,
        oldAvatar: user.oldAvatar || null,
        fallbackAvatar: user.avatar || null
    });
};


/***/ }),

/***/ 17562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23018);
/* harmony import */ var _icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93303);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _P2_P2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72560);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76356);
/* harmony import */ var _IconButton_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42531);









var BreadCrumb = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezseds00",
    label: "BreadCrumb"
})("border:1px solid var(--color-divider);");
var StyledCrumbs = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(BreadCrumb, {
    target: "ezseds01",
    label: "StyledCrumbs"
})("padding:", function(param) {
    var $padding = param.$padding;
    return $padding;
}, ";transform:skew(-20deg);height:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_8B */ .t8.B3, ";background-color:var(--color-base-1);margin:auto ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_6 */ .t8.A1, ";cursor:pointer;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";@media only screen and (max-width:47.95em){display:none;}");
var Unskew = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_P2_P2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "ezseds02",
    label: "Unskew"
})("transform:skew(20deg);color:var(--color-text-primary);white-space:nowrap;text-overflow:ellipsis;max-width:280px;overflow:hidden;");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezseds03",
    label: "Wrapper"
})("display:flex;-ms-overflow-style:none;scrollbar-width:none;overflow:auto;&::-webkit-scrollbar{display:none;}");
var BackButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "ezseds04",
    label: "BackButton"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_3B */ .t8.N, ";box-shadow:none;background-color:var(--color-base-1);");
var BreadCrumbs = function(param) {
    var tags = param.tags, className = param.className, onBackClick = param.onBackClick, useBackClick = param.useBackClick, padding = param.padding;
    var tagsLength = (tags === null || tags === void 0 ? void 0 : tags.length) || 0;
    var lastLink = tagsLength > 0 && !useBackClick ? tags === null || tags === void 0 ? void 0 : tags[tagsLength - 1] : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(Wrapper, {
        className: className,
        children: [
            lastLink ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: lastLink.href,
                as: lastLink.as,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BreadCrumb, {
                    as: BackButton,
                    bgColor: "var(--color-base-0)",
                    hovDisabled: true,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        size: _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM,
                        color: "var(--color-text-primary)"
                    })
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BreadCrumb, {
                as: BackButton,
                onClick: onBackClick,
                bgColor: "var(--color-base-0)",
                hovDisabled: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM,
                    color: "var(--color-text-primary)"
                })
            }),
            tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(StyledCrumbs, {
                    $padding: padding,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        href: tag.href,
                        as: tag.as,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Unskew, {
                            children: tag.title
                        })
                    })
                }, tag.title);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbs);
BreadCrumbs.propTypes = {
    padding: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    tags: prop_types__WEBPACK_IMPORTED_MODULE_8___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_8___default().shape({
        title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
        as: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
        href: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired)
    })),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    onBackClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func),
    useBackClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool)
};
BreadCrumbs.defaultProps = {
    padding: "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_5B */ .t8.zj),
    className: "",
    tags: [],
    onBackClick: _utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__/* .goBack */ .Hm,
    useBackClick: false
};


/***/ }),

/***/ 84566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K1": function() { return /* binding */ HEADER_TABS; },
/* harmony export */   "K7": function() { return /* binding */ OFFLINE_CENTER_ICONS; },
/* harmony export */   "NK": function() { return /* binding */ SUBSCRIPTION; },
/* harmony export */   "NW": function() { return /* binding */ TABSID; },
/* harmony export */   "TJ": function() { return /* binding */ OFFLINE_CENTER_CTA; },
/* harmony export */   "Tl": function() { return /* binding */ SUCCESS_STORY; },
/* harmony export */   "Y7": function() { return /* binding */ STORE_TAB; },
/* harmony export */   "Yz": function() { return /* binding */ ABOUT_EXAM_SEC; },
/* harmony export */   "ch": function() { return /* binding */ ABOUT_TAB; },
/* harmony export */   "d6": function() { return /* binding */ GOAL_HOME; },
/* harmony export */   "g": function() { return /* binding */ BATCHES_SEC; },
/* harmony export */   "js": function() { return /* binding */ learnerDefaultProps; },
/* harmony export */   "rM": function() { return /* binding */ plusSubscriptionTiles; },
/* harmony export */   "rn": function() { return /* binding */ DEFAULT_STORE_TAB; },
/* harmony export */   "t6": function() { return /* binding */ educatorDefaultProps; },
/* harmony export */   "ud": function() { return /* binding */ STORE; },
/* harmony export */   "uv": function() { return /* binding */ EDUCATORS_SEC; },
/* harmony export */   "v4": function() { return /* binding */ GET_STARTED; }
/* harmony export */ });
/* unused harmony exports STORE_MAP, EDUCATORS, BATCH, SUBSCRIPTION_PLANS, SUCCESS_STORIES, ABOUT_EXAM, NEW_GOAL_PAGE_EXP */
// page 1 block id
var GET_STARTED = "getStarted";
var EDUCATORS_SEC = "educatorsSection";
var BATCHES_SEC = "batchesSection";
var ABOUT_EXAM_SEC = "aboutExamSection";
var STORE = "store";
// page name
var GOAL_HOME = "Goal home";
var SUBSCRIPTION = "Goal subscription";
var SUCCESS_STORY = "success story";
var STORE_MAP = "store";
//
var EDUCATORS = "educators";
var BATCH = "batch";
var SUBSCRIPTION_PLANS = "subscription plans";
var SUCCESS_STORIES = "success stories";
var ABOUT_EXAM = "about exam";
var TABSID = {
    GET_STARTED: "tab_get_started",
    EDUCATORS_SEC: "tab_educators",
    BATCHES_SEC: "tab_batch",
    SUBSCRIPTION_PLANS: "tab_subscription_plans",
    SUCCESS_STORIES: "tab_success_stories",
    ABOUT_EXAM: "tab_about_exam",
    STORE: "tab_store"
};
var ABOUT_TAB = {
    id: "tab_about_exam",
    label: "About exam",
    sectionName: "about exam",
    sectionId: ABOUT_EXAM_SEC,
    hash: "about-exam",
    page: "" // for new page tab
};
var STORE_TAB = {
    id: "tab_store",
    label: "Store",
    sectionName: "store",
    sectionId: "",
    hash: "",
    page: "store"
};
var HEADER_TABS = [
    {
        id: "tab_get_started",
        label: "Get started",
        sectionName: "getStarted",
        sectionId: GET_STARTED,
        hash: "",
        page: "Goal home"
    },
    {
        id: "tab_educators",
        label: "Educators",
        sectionId: EDUCATORS_SEC,
        sectionName: "educators",
        hash: "educators",
        page: ""
    },
    {
        id: "tab_batch",
        label: "Batch",
        sectionId: BATCHES_SEC,
        sectionName: "batch",
        hash: "batches",
        page: ""
    },
    {
        id: "tab_subscription_plans",
        label: "Subscription plan",
        sectionId: "",
        sectionName: "subscription plans",
        hash: "",
        page: "Goal subscription"
    },
    {
        id: "tab_success_stories",
        label: "Success stories",
        sectionId: "",
        sectionName: "success stories",
        hash: "",
        page: "success story"
    }
];
// Install banner deafult props
var educatorDefaultProps = {
    title: "All in one place",
    description: "Schedule your classes, engage with learners, see your performance across your courses",
    androidApp: "https://play.google.com/store/apps/details?id=com.unacademy&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26",
    iosApp: "https://apps.apple.com/in/app/unacademy-educator-app/id1156375099%26referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526"
};
var learnerDefaultProps = {
    title: "Online preparation like never before",
    description: [
        "Interactive live classes",
        "Mock tests and practice questions",
        "High-quality notes",
        "Doubt solving"
    ],
    androidApp: "https://play.google.com/store/apps/details?id=com.unacademyapp&referrer=utm_source%3DFooter%26utm_medium%3DWebApp%26utm_campaign%3DFooter%26",
    iosApp: "https://apps.apple.com/in/app/unacademy-learning-app/id1342565069?referrer%3Dutm_source%253DFooter%2526utm_medium%253DWebApp%2526utm_campaign%253DFooter%2526"
};
// exp name
var NEW_GOAL_PAGE_EXP = "web_landing_page_redesign";
// Default Store Tab Experiment key
var DEFAULT_STORE_TAB = "default_store_tab";
// offline center icons file maping
var OFFLINE_CENTER_ICONS = {
    indore: "/offlineCentres/indore_V1.svg",
    kota: "/offlineCentres/kota.svg",
    lucknow: "/offlineCentres/lucknow.svg",
    noida: "/offlineCentres/noida.svg",
    patna: "/offlineCentres/patna.svg",
    ahmedabad: "/offlineCentres/ahmedabad.svg",
    bangalore: "/offlineCentres/bangalore.svg",
    delhi: "/offlineCentres/delhi.svg",
    chandigarh: "/offlineCentres/chandigarh.svg",
    jaipur: "/offlineCentres/jaipur.svg",
    pune: "/offlineCentres/pune.svg",
    vijayawada: "/offlineCentres/vijayawada.svg",
    morecities: "/offlineCentres/morecities.svg",
    viewAll: "/offlineCentres/viewAll.svg"
};
// offline cenetr CTA url
var OFFLINE_CENTER_CTA = {
    TMUVD: "/goal/kota-neet-coaching/TMUVD/centre/Kota-Centre/NXG6I0UBPB",
    YOTUH: "/goal/kota-neet-coaching/YOTUH/centre/Kota-Centre/NXG6I0UBPB" // pragma: allowlist secret
};
// tiles content for sbscription page when only one subscription is avaialble
var plusSubscriptionTiles = [
    {
        subLabel: "Learn with the best educators for online IIT JEE preparation",
        label: "India's top educators"
    },
    {
        subLabel: "Follow all your classes, practice & mock tests on a single unified planner",
        label: "Fully organized planner"
    },
    {
        subLabel: "Live classes, practice questions, mock tests, doubt solving and much more",
        label: "Best-in-class learning experience"
    },
    {
        subLabel: "10000+ questions in the question-bank with detailed soultions, report and insights",
        label: "Tests and unlimited practice"
    }
];


/***/ }),

/***/ 44204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _base_Paper_Paper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59485);
/* harmony import */ var aquilla_core_atoms_Typography_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51513);
/* harmony import */ var aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92378);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80867);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17579);
/* harmony import */ var _cont_Login_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43605);
/* harmony import */ var _events_sendAnalytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99691);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43135);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2080);
/* harmony import */ var _stores_selectors_ttuSelectors__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(29870);
/* harmony import */ var aquilla_icons_actions_Call__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56074);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87936);
/* harmony import */ var _stores_ttu__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(94835);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(73060);
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(59375);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50420);


/* eslint-disable react/forbid-prop-types */ 



















var TTUContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Paper_Paper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e17v9l6i0",
    label: "TTUContainer"
})("max-width:1136px;width:100%;margin:160px auto;position:relative;display:flex;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_12B */ .t8.SL, " ", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_16B */ .t8.hN, ";", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{flex-direction:column;margin:0px !important;margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM, " !important;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM, " !important;padding:0px !important;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_6B */ .t8.BY, " !important;}justify-content:space-between;");
var AboutWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e17v9l6i1",
    label: "AboutWrapper"
})("display:flex;flex-direction:column;justify-content:center;margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_25B */ .t8.ge, ";", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{flex-direction:row;margin-right:0px !important;}");
var StyledP1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_atoms_Typography_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    target: "e17v9l6i2",
    label: "StyledP1"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_2B */ .t8.Rw, ";margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_10B */ .t8.FC, ";color:var(--color-text-primary);font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Fonts.LARGE */ .F3.ln, ";");
var IllustrationContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e17v9l6i3",
    label: "IllustrationContainer"
})("position:relative;width:160px;height:160px;margin-top:-", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var CallLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_atoms_Typography_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    target: "e17v9l6i4",
    label: "CallLabel"
})("font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Fonts.H7 */ .F3.H7, ";font-weight:700;line-height:150%;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_1B */ .t8.MK, ";color:var(--color-text-secondary);");
var Options = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e17v9l6i5",
    label: "Options"
})("display:flex;align-items:center;", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{flex-direction:column;}");
var StyledBtn = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    target: "e17v9l6i6",
    label: "StyledBtn"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_5B */ .t8.zj, ";background-color:var(--color-base-fill);color:var(--color-text-tertiary);", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin-right:0px !important;}");
var Divider = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e17v9l6i7",
    label: "Divider"
})("width:0;height:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_8B */ .t8.B3, ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_5B */ .t8.zj, ";border:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_1 */ .t8.tF, " solid var(--color-divider);");
var BottomDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e17v9l6i8",
    label: "BottomDiv"
})("display:flex;flex-direction:column;");
var LeftDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e17v9l6i9",
    label: "LeftDiv"
})();
var Phone = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("a", {
    target: "e17v9l6i10",
    label: "Phone"
})("display:flex;width:fit-content;align-items:center;gap:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var CallDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e17v9l6i11",
    label: "CallDiv"
})("display:flex;margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_6B */ .t8.BY, ";");
var HaveQuestionAboutGoalHeading = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_atoms_Typography_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
    target: "e17v9l6i12",
    label: "HaveQuestionAboutGoalHeading"
})("color:var(--color-text-primary);width:100%;");
var Banner = function(param) {
    var goalDetails = param.goalDetails, className = param.className, _ttuConfig = param.ttuConfig, ttuConfig = _ttuConfig === void 0 ? {} : _ttuConfig;
    var isMobile = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)().isMobile;
    var title = ttuConfig.title, _subTitle = ttuConfig.subTitle, subTitle = _subTitle === void 0 ? "Our expert can answer all your questions" : _subTitle, _imgUrl = ttuConfig.imgUrl, imgUrl = _imgUrl === void 0 ? "ttu/ttu_illustration_call.svg" : _imgUrl, _ttuEventsProps = ttuConfig.ttuEventsProps, ttuEventsProps = _ttuEventsProps === void 0 ? _constants_empty__WEBPACK_IMPORTED_MODULE_15__/* .emptyObject */ .FD : _ttuEventsProps, phone = ttuConfig.phone, buttonCTA = ttuConfig.buttonCTA, _isOffline = ttuConfig.isOffline, isOffline = _isOffline === void 0 ? false : _isOffline;
    var showData = (0,_stores_ttu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_stores_selectors_ttuSelectors__WEBPACK_IMPORTED_MODULE_17__/* .getTTUShowData */ ._p);
    var showTTUCurtain = (0,_stores_ttu__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_stores_selectors_ttuSelectors__WEBPACK_IMPORTED_MODULE_17__/* .getShowTTUCurtain */ .qv);
    var meData = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_18__/* .getMe */ .jo);
    var userType = (showData === null || showData === void 0 ? void 0 : showData.isRepeatUser) ? "Repeat" : "New";
    if (!(showData === null || showData === void 0 ? void 0 : showData.isRepeatUser) && ((showData === null || showData === void 0 ? void 0 : showData.state) === _cont_Login_constants__WEBPACK_IMPORTED_MODULE_6__/* .TalkState.NO_SHOW */ .Gn.NO_SHOW || (showData === null || showData === void 0 ? void 0 : showData.state) === _cont_Login_constants__WEBPACK_IMPORTED_MODULE_6__/* .TalkState.LOCAL_NO_SHOW */ .Gn.LOCAL_NO_SHOW)) {
        userType = "Scheduled";
    }
    var phoneNumber = phone || ((showData === null || showData === void 0 ? void 0 : showData.countryCode) && (showData === null || showData === void 0 ? void 0 : showData.phoneNumber) ? "".concat(showData === null || showData === void 0 ? void 0 : showData.countryCode, " ").concat(showData === null || showData === void 0 ? void 0 : showData.phoneNumber) : _constants_index__WEBPACK_IMPORTED_MODULE_8__/* .inboundCallNumber */ .nI);
    var onPhoneNumberClick = (0,react__WEBPACK_IMPORTED_MODULE_11__.useCallback)(function() {
        _actions_analytics__WEBPACK_IMPORTED_MODULE_12__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_5__/* .TTU_NUMBER_CLICKED */ .h4X, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
            inbound_phone_number: phoneNumber
        }, ttuEventsProps), _constants_index__WEBPACK_IMPORTED_MODULE_8__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY);
    }, [
        phoneNumber,
        ttuEventsProps
    ]);
    if (isMobile) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(TTUContainer, {
            className: className,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(AboutWrapper, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(LeftDiv, {
                            className: "ttu-left",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(HaveQuestionAboutGoalHeading, {
                                    variant: "h2",
                                    className: "ttu-title",
                                    children: [
                                        title || null,
                                        !title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .Fragment */ .HY, {
                                            children: [
                                                "Have questions about",
                                                " ".concat((goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.name) || " ", " subscription?")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(StyledP1, {
                                    className: "ttu-description",
                                    children: subTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(IllustrationContainer, {
                            className: "ttu-illustration-container",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                alt: "Talk To Unacademy",
                                src: imgUrl,
                                layout: "fill"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(BottomDiv, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(Options, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(StyledBtn, {
                                label: buttonCTA || "Get a call from us",
                                fullWidth: true,
                                size: "large",
                                onClick: function() {
                                    (0,_events_sendAnalytics__WEBPACK_IMPORTED_MODULE_7__/* .sendTTUEvents */ .cS)(_constants_segment__WEBPACK_IMPORTED_MODULE_5__/* .TTU_POP_UP_CLICK */ .Oct, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                                        user_ttu_status: userType,
                                        source: "Bottom Home Screen",
                                        last_primary_source_section: "Bottom Home Screen"
                                    }, ttuEventsProps), meData === null || meData === void 0 ? void 0 : meData.uid, meData === null || meData === void 0 ? void 0 : meData.username, goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.uid, goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.name);
                                    if (goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.uid) {
                                        showTTUCurtain(true, "Bottom Home Screen");
                                    } else {
                                        window.open("/talktous?isOffline=".concat(isOffline), "_blank");
                                    }
                                }
                            }),
                            phoneNumber && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(CallDiv, {
                                className: "ttu-call",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(CallLabel, {
                                        children: "Or call us"
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(Phone, {
                                        href: "tel:".concat(phoneNumber),
                                        onClick: onPhoneNumberClick,
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(aquilla_icons_actions_Call__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                height: _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM,
                                                width: _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM,
                                                color: "var(--color-text-primary)"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(aquilla_core_atoms_Typography_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                                variant: "h6",
                                                children: phoneNumber
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(TTUContainer, {
        className: className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(AboutWrapper, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(HaveQuestionAboutGoalHeading, {
                        variant: "h2",
                        className: "ttu-title",
                        children: [
                            title || null,
                            !title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .Fragment */ .HY, {
                                children: [
                                    "Have questions about",
                                    " ".concat((goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.name) || " ", " subscription?")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(StyledP1, {
                        className: "ttu-description",
                        children: subTitle
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(Options, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(StyledBtn, {
                                label: "Get a call from us",
                                size: "large",
                                onClick: function() {
                                    (0,_events_sendAnalytics__WEBPACK_IMPORTED_MODULE_7__/* .sendTTUEvents */ .cS)(_constants_segment__WEBPACK_IMPORTED_MODULE_5__/* .TTU_POP_UP_CLICK */ .Oct, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({
                                        user_ttu_status: userType,
                                        source: "Bottom Home Screen",
                                        last_primary_source_section: "Bottom Home Screen"
                                    }, ttuEventsProps), meData === null || meData === void 0 ? void 0 : meData.uid, meData === null || meData === void 0 ? void 0 : meData.username, goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.uid, goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.name);
                                    if (goalDetails === null || goalDetails === void 0 ? void 0 : goalDetails.uid) {
                                        showTTUCurtain(true, "Bottom Home Screen");
                                    } else {
                                        window.open("/talktous?isOffline=".concat(isOffline), "_blank");
                                    }
                                }
                            }),
                            phoneNumber && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .Fragment */ .HY, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(Divider, {}),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(CallLabel, {
                                                variant: "p1",
                                                children: "Or call us"
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsxs */ .BX)(Phone, {
                                                href: "tel:".concat(phoneNumber),
                                                onClick: onPhoneNumberClick,
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(aquilla_icons_actions_Call__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                        height: _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM,
                                                        width: _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM,
                                                        color: "var(--color-text-primary)"
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(aquilla_core_atoms_Typography_Typography__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                                                        variant: "h6",
                                                        children: phoneNumber
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(IllustrationContainer, {
                className: "ttu-illustration-container",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                    alt: "Talk To Unacademy",
                    src: imgUrl,
                    layout: "fill"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Banner);
Banner.propTypes = {
    goalDetails: prop_types__WEBPACK_IMPORTED_MODULE_21___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_21___default().any)).isRequired,
    className: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string)
};
Banner.defaultProps = {
    className: ""
};


/***/ }),

/***/ 6858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useFirstRenderSkip = function(callback, deps) {
    var isFirstRenderingDone = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isFirstRenderingDone.current) callback();
        else isFirstRenderingDone.current = true;
    }, deps);
};
/* harmony default export */ __webpack_exports__["Z"] = (useFirstRenderSkip);


/***/ }),

/***/ 88678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ classes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/swr/infinite/dist/index.mjs
var infinite_dist = __webpack_require__(44593);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/seo/index.jsx + 2 modules
var seo = __webpack_require__(14432);
// EXTERNAL MODULE: ./src/stores/sidenav.js
var sidenav = __webpack_require__(19204);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./src/components/Base/Paper/Paper.jsx
var Paper = __webpack_require__(59485);
// EXTERNAL MODULE: ./src/components/Base/H2/H2.jsx
var H2 = __webpack_require__(39396);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/components/Container/TalkToUnacademy/Banner.jsx
var Banner = __webpack_require__(44204);
// EXTERNAL MODULE: ./src/api/hooks/topology/useTopology.js
var useTopology = __webpack_require__(71609);
// EXTERNAL MODULE: ./src/components/Container/NewPreSubscribed/AllAboutExam.jsx
var AllAboutExam = __webpack_require__(93544);
// EXTERNAL MODULE: ./src/hooks/useWindowSize.js
var useWindowSize = __webpack_require__(50420);
// EXTERNAL MODULE: ./src/redux/selectors/subscription.js
var subscription = __webpack_require__(83553);
// EXTERNAL MODULE: ./src/stores/ttu.js
var ttu = __webpack_require__(94835);
// EXTERNAL MODULE: ./src/stores/selectors/ttuSelectors.js
var ttuSelectors = __webpack_require__(29870);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/aquilla/core/atoms/Typography/index.js
var Typography = __webpack_require__(82353);
// EXTERNAL MODULE: ./src/utils/breadcrumbs.js
var breadcrumbs = __webpack_require__(23018);
// EXTERNAL MODULE: ./src/components/Base/BreadCrumbs/BreadCrumbs.jsx
var BreadCrumbs = __webpack_require__(17562);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/Base/CircularLoader/CircularLoader.jsx
var CircularLoader = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/InfiniteFeedRow.jsx
var InfiniteFeedRow = __webpack_require__(5015);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/DynamicFeedTypeBlock.jsx + 1 modules
var DynamicFeedTypeBlock = __webpack_require__(2252);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/utils/getBlockType.js
var getBlockType = __webpack_require__(58483);
// EXTERNAL MODULE: ./src/redux/actions/courses.js
var courses = __webpack_require__(5861);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/components/Container/SWRInfiniteFeedRow/useInfiniteFeedRow.js + 9 modules
var useInfiniteFeedRow = __webpack_require__(5700);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/api/fetchers/index.js
var fetchers = __webpack_require__(19982);
// EXTERNAL MODULE: ./src/utils/api-helper/host.js
var host = __webpack_require__(54051);
;// CONCATENATED MODULE: ./src/api/fetchers/free-live-classes/index.js




var defaultHost = (0,host/* getHost */.XF)();
var getFeedAPI = function(param) {
    var goalUID = param.goalUID, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
    return "".concat(defaultHost, "v1/uplus/special_class/home/?goal_uid=").concat(goalUID, "&limit=").concat(limit, "&offset=").concat(offset, "&v=10");
};
var fetchSpecialClassesFeed = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var goalUID, _limit, limit, _offset, offset;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    goalUID = param.goalUID, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit, _offset = param.offset, offset = _offset === void 0 ? 0 : _offset;
                    return _ctx.abrupt("return", (0,fetchers/* simpleFetch */.l)(getFeedAPI({
                        goalUID: goalUID,
                        limit: limit,
                        offset: offset
                    })));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchSpecialClassesFeed(_) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/Container/FreeLiveClasses/useEntireFeed.js


var useEntireFeed = function(param) {
    var goalUID = param.goalUID, _limit = param.limit, limit = _limit === void 0 ? 3 : _limit;
    return (0,useInfiniteFeedRow/* default */.Z)({
        initialURL: getFeedAPI({
            goalUID: goalUID,
            limit: limit
        }),
        swrOptions: {
            revalidateOnMount: false,
            revalidateFirstPage: false
        }
    });
};
/* harmony default export */ var FreeLiveClasses_useEntireFeed = (useEntireFeed);

;// CONCATENATED MODULE: ./src/components/Container/FreeLiveClasses/EntireFeed.jsx

















var LoaderWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1fv4z2o0",
    label: "LoaderWrapper"
})("grid-column:span 18;display:flex;justify-content:center;align-items:center;");
var renderLoader = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularLoader/* default */.Z, {})
    });
};
var EntireFeed = function(param) {
    var sectionMetaInfo = param.sectionMetaInfo;
    var router = (0,next_router.useRouter)();
    var goalUID = router.query.goalUID;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var ref = (0,useTopology/* default */.Z)(goalUID, {
        revalidateOnMount: false
    }), goalTopology = ref.topology;
    var ref1 = FreeLiveClasses_useEntireFeed({
        goalUID: goalUID
    }), data = ref1.data, isValidating = ref1.isValidating, refetchEntireFeed = ref1.mutate, fetchMoreData = ref1.fetchMoreData;
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            refetchEntireFeed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    var enroll = function(course) {
        return function() {
            return dispatch((0,courses/* toggleEnrolledCourse */.eL)(course.uid, !course.isEnrolled));
        };
    };
    var goalSlug = goalTopology.goalSlug;
    var getLinkAndHrefProps = function(type, max, min) {
        var viewAllLink = max > min ? "/goal/".concat(goalSlug, "/").concat(goalUID, "/classes/").concat(type) : null;
        var viewAllHref = "/goal/[goalSlug]/[goalUID]/classes/[type]";
        return {
            viewAllLink: viewAllLink,
            viewAllHref: viewAllHref
        };
    };
    var renderItem = function(feed, index) {
        var feedType = feed.type;
        var feedEntityType = feed.extraBlockinfo.entityType;
        var updatedFeed = (0,_object_spread/* default */.Z)({}, feed);
        if (sectionMetaInfo[feedType]) {
            var _feedType = sectionMetaInfo[feedType], label = _feedType.label, description = _feedType.description;
            updatedFeed = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, updatedFeed), {
                label: label,
                description: description
            });
        }
        var extraProps = {
            goalSlug: goalSlug,
            goalUID: goalUID,
            index: index,
            goal: goalTopology,
            lastPrimarySource: "Special Class Feed",
            type: "special",
            refetchEntireFeed: refetchEntireFeed
        };
        if ((0,getBlockType/* isTestSeriesEntityType */.Bh)(feedEntityType)) {
            var ref;
            var feedCount = ((ref = feed.extraBlockinfo) === null || ref === void 0 ? void 0 : ref.count) || 0;
            extraProps = (0,_object_spread/* default */.Z)({}, extraProps, getLinkAndHrefProps(feedType, feedCount, 3));
        }
        if ((0,getBlockType/* isEducatorEntityType */.vr)(feedEntityType)) {
            var ref1;
            var feedCount1 = ((ref1 = feed.extraBlockinfo) === null || ref1 === void 0 ? void 0 : ref1.count) || 0;
            extraProps = (0,_object_spread/* default */.Z)({}, extraProps, getLinkAndHrefProps(feedType, feedCount1, 0));
        }
        if ((0,getBlockType/* isCourseEntityType */.Mm)(feedEntityType)) {
            var ref2;
            var feedCount2 = ((ref2 = feed.extraBlockinfo) === null || ref2 === void 0 ? void 0 : ref2.count) || 0;
            extraProps = (0,_object_spread/* default */.Z)({}, extraProps, getLinkAndHrefProps(feedType, feedCount2, 3));
        }
        if ((0,getBlockType/* isCarouselEntityType */.ek)(feedEntityType) || (0,getBlockType/* isBannerEntityType */.ur)(feedEntityType)) {
            extraProps.onEnroll = enroll;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicFeedTypeBlock/* default */.Z, (0,_object_spread/* default */.Z)({
            feedBlock: updatedFeed
        }, extraProps), feedType);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfiniteFeedRow/* default */.Z, {
        data: data.results,
        isLoading: isValidating,
        renderItem: renderItem,
        renderLoader: renderLoader,
        onLoadMore: fetchMoreData
    });
};
/* harmony default export */ var FreeLiveClasses_EntireFeed = (EntireFeed);
EntireFeed.propTypes = {
    sectionMetaInfo: prop_types_default().objectOf((prop_types_default()).any)
};
EntireFeed.defaultProps = {
    sectionMetaInfo: {}
};

;// CONCATENATED MODULE: ./src/components/Container/FreeLiveClasses/FreeLiveClasses.jsx

/* eslint-disable @next/next/no-img-element */ 

















var StyledPaper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Paper/* default */.Z, {
    target: "e12h0brb0",
    label: "StyledPaper"
})("display:flex;flex-direction:column;align-items:baseline;margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";padding:", styleConstants/* Spacings.SPACING_8B */.t8.B3, " ", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";background:var(--color-base-1);img{height:64px;width:64px;}", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{background:var(--color-base-0);padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, " ", styleConstants/* Spacings.SPACING_0B */.t8.NE, " ", styleConstants/* Spacings.SPACING_0B */.t8.NE, ";box-shadow:none;flex-direction:column;align-items:flex-start;img{display:none;}}");
var StyH2 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H2/* default */.Z, {
    target: "e12h0brb1",
    label: "StyH2"
})("margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";color:var(--color-text-primary);", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{font-size:", styleConstants/* Fonts.H3 */.F3.H3, ";line-height:", styleConstants/* Spacings.SPACING_7B */.t8.d5, ";}");
var WrapperTTU = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e12h0brb2",
    label: "WrapperTTU"
})("grid-column:span 18;");
var Description = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Typography/* default */.ZP, {
    target: "e12h0brb3",
    label: "Description"
})("color:var(--color-text-secondary);margin-top:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";");
var FreeLiveClasses = function(param) {
    var goal = param.goal, pageMetaInfo = param.pageMetaInfo;
    var router = (0,next_router.useRouter)();
    var goalUID = router.query.goalUID;
    var ref = (0,useTopology/* default */.Z)(goalUID), goalTopology = ref.topology;
    var isMobile = (0,useWindowSize/* default */.Z)().isMobile;
    var isGoalEnabled = (0,ttu/* default */.Z)(ttuSelectors/* getTTUIsGoalEnabled */.AP);
    var isSubscribed = (0,es/* useSelector */.v9)(subscription/* getIsSubscribed */.pg);
    var goalName = goalTopology.name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPaper, {
                gridColumn: "span 18",
                padding: "".concat(styleConstants/* Spacings.SPACING_10B */.t8.FC, " ").concat(styleConstants/* Spacings.SPACING_12B */.t8.SL),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* default */.Z, {
                        onBackClick: breadcrumbs/* goBack */.Hm,
                        tags: breadcrumbs/* default.getFreeLiveClassesTags */.ZP.getFreeLiveClassesTags(goal),
                        useBackClick: true
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH2, {
                        as: "h1",
                        children: (pageMetaInfo === null || pageMetaInfo === void 0 ? void 0 : pageMetaInfo.title) || goalName
                    }),
                    (pageMetaInfo === null || pageMetaInfo === void 0 ? void 0 : pageMetaInfo.description) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                        variant: "p2",
                        children: pageMetaInfo.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeLiveClasses_EntireFeed, {
                sectionMetaInfo: pageMetaInfo === null || pageMetaInfo === void 0 ? void 0 : pageMetaInfo.CUSTOM_FEED
            }),
            isGoalEnabled && !isSubscribed && !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WrapperTTU, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Banner/* default */.Z, {
                    goalDetails: goal
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AllAboutExam/* default */.Z, {
                width: "848px"
            })
        ]
    });
};
/* harmony default export */ var FreeLiveClasses_FreeLiveClasses = (FreeLiveClasses);
FreeLiveClasses.propTypes = {
    pageMetaInfo: prop_types_default().objectOf((prop_types_default()).any)
};
FreeLiveClasses.defaultProps = {
    pageMetaInfo: {}
};

// EXTERNAL MODULE: ./src/seo/goal/subGoal.js
var subGoal = __webpack_require__(94004);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/layout/index.jsx + 26 modules
var layout = __webpack_require__(41566);
// EXTERNAL MODULE: ./src/components/Container/App/PageReduxProviderWrapper.jsx
var PageReduxProviderWrapper = __webpack_require__(27300);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
// EXTERNAL MODULE: ./src/utils/getCustomPageDetails.js
var getCustomPageDetails = __webpack_require__(70507);
// EXTERNAL MODULE: ./src/utils/session/validateAndSetSessionId.ts
var validateAndSetSessionId = __webpack_require__(32415);
// EXTERNAL MODULE: ./src/utils/cookies.js
var cookies = __webpack_require__(18113);
// EXTERNAL MODULE: ./src/api/fetchers/experiments/index.js
var experiments = __webpack_require__(97163);
// EXTERNAL MODULE: ./src/utils/abHelper.js
var abHelper = __webpack_require__(76226);
// EXTERNAL MODULE: ./src/stores/experiments.js
var stores_experiments = __webpack_require__(19271);
;// CONCATENATED MODULE: ./src/pages/goal/[goalSlug]/[goalUID]/classes.jsx
























var FreeLiveClassesPageWithSEO = function(param) {
    var goal = param.goal, querySlug = param.querySlug;
    var ref = goal || {}, slug = ref.slug, goalTitle = ref.title, uid = ref.uid, ogImage = ref.ogImage;
    var pageMetaInfo = (0,getCustomPageDetails/* getCustomPageDetails */.U)(goal === null || goal === void 0 ? void 0 : goal.name, goal === null || goal === void 0 ? void 0 : goal.title, segment/* FREE_CLASSES_AND_TESTS */.a_Z);
    var ref1 = (0,AppCommonData/* usePageSeoContent */.tS)(), title = ref1.title, description = ref1.description;
    var metaTitle = title || "Free Live Classes | ".concat(goalTitle, " | Unacademy");
    var metaDescription = description || "Prepare live from Top Educators with comprehensive, structured and crash courses along with practice section for ".concat(goalTitle, " on Unacademy Plus.");
    var canonicalURL = "https://unacademy.com/goal/".concat(slug, "/").concat(uid, "/classes");
    var imageURL = ogImage || "https://static.uacdn.net/static/dist/c76c2e18c7980818a913f9467c74c567.png";
    (0,sidenav/* useSetSelectedNav */.WF)("classes");
    var isFreeUser = (0,useMyInfo/* default */.Z)((0,auth/* getIsFreeUser */.tj)(goal === null || goal === void 0 ? void 0 : goal.uid));
    var isLoggedIn = (0,useMyInfo/* default */.Z)(auth/* getIsLoggedIn */.M7);
    var accessToken = (0,cookies/* readCookie */.vQ)("accessToken");
    (0,react.useEffect)(function() {
        if (querySlug !== slug) (0,pushRoute/* default */.Z)("/goal/[goalSlug]/[goalUID]/classes", "/goal/".concat(slug, "/").concat(uid, "/classes"), {
            shallow: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        (0,validateAndSetSessionId/* default */.ZP)();
        var deviceID = cookies/* default.readCookie */.ZP.readCookie(validateAndSetSessionId/* DEVICE_ID_COOKIE_NAME */.CR);
        if (!accessToken || accessToken && isLoggedIn && isFreeUser) {
            (0,experiments/* fetchABExperimentData */.d)("notify_me_and_follow_educator_component", abHelper/* abProxyJWT */.q_, deviceID);
        } else if (accessToken && isLoggedIn && !isFreeUser) {
            (0,stores_experiments/* setExperimentVariation */.Wb)("notify_me_and_follow_educator_component", null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accessToken,
        isLoggedIn,
        isFreeUser
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                title: metaTitle,
                description: metaDescription,
                openGraph: {
                    title: metaTitle,
                    description: metaDescription,
                    images: [
                        {
                            url: imageURL
                        }
                    ],
                    url: canonicalURL
                },
                schema: (0,subGoal/* default */.Z)({
                    goal: goal,
                    description: metaDescription,
                    subGoal: {
                        name: "Free classes & tests",
                        link: "classes"
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: metaTitle
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeLiveClasses_FreeLiveClasses, {
                goal: goal,
                pageMetaInfo: pageMetaInfo
            })
        ]
    });
};
var FreeLiveClassesPageWithSWRConfig = function(param) {
    var goal = param.goal, classesFeedFallbackData = param.classesFeedFallbackData;
    var key = (0,infinite_dist/* unstable_serialize */.wE)(function() {
        return getFeedAPI({
            goalUID: goal.uid
        });
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* SWRConfig */.J$, {
        value: {
            revalidateOnMount: false,
            dedupingInterval: 60 * 1000,
            fallback: (0,_define_property/* default */.Z)({}, key, [
                classesFeedFallbackData
            ])
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeLiveClassesPageWithSEO, {
            goal: goal
        })
    });
};
FreeLiveClassesPageWithSWRConfig.Layout = layout/* default */.Z;
FreeLiveClassesPageWithSWRConfig.Wrapper = PageReduxProviderWrapper["default"];
FreeLiveClassesPageWithSWRConfig.pageInfo = {
    isMWebSupported: true,
    name: segment/* FREE_CLASSES_AND_TESTS */.a_Z,
    layoutOptions: {
        showPlusNav: true
    },
    isCMSMeta: true
};
var __N_SSG = true;
/* harmony default export */ var classes = (FreeLiveClassesPageWithSWRConfig);


/***/ }),

/***/ 94004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _seo_schemas_subListing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84028);
/* harmony import */ var _schemas_breadcrumb__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29630);


var subGoalSchema = function(param) {
    var _goal = param.goal, goal = _goal === void 0 ? {} : _goal, _subGoal = param.subGoal, subGoal = _subGoal === void 0 ? {} : _subGoal, description = param.description;
    var graph = [];
    var subGoalLink = "".concat(goal.permalink, "/").concat(subGoal.link);
    var breads = [
        {
            name: "Home",
            url: "https://unacademy.com"
        },
        {
            name: "Explore",
            url: "https://unacademy.com/explore"
        },
        {
            name: goal.name,
            url: goal.permalink
        },
        {
            name: subGoal.name,
            url: subGoalLink
        }
    ];
    graph.push((0,_schemas_breadcrumb__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(breads));
    graph.push((0,_seo_schemas_subListing__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        topic: goal.name,
        forPlus: true,
        name: "".concat(goal.name, " ").concat(subGoal.name),
        description: description,
        link: subGoalLink
    }));
    var schema = {
        "@context": "https://schema.org/",
        "@graph": graph
    };
    return schema;
};
/* harmony default export */ __webpack_exports__["Z"] = (subGoalSchema);


/***/ }),

/***/ 29630:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var breadCrumbSchema = function(breads) {
    var schema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList"
    };
    schema.itemListElement = breads.filter(function(bread) {
        return bread.name && bread.url;
    }).map(function(bread, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            name: bread.name,
            item: bread.url
        };
    });
    return schema;
};
/* harmony default export */ __webpack_exports__["Z"] = (breadCrumbSchema);


/***/ }),

/***/ 84028:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var subListing = function(course) {
    var topic = course.topic, name = course.name, forPlus = course.forPlus, description = course.description, link = course.link;
    return [
        {
            hasCourseInstance: {
                "@type": "CourseInstance",
                courseMode: "Online"
            },
            "@id": link,
            about: {
                name: topic
            },
            "@context": "http://schema.org",
            isAccessibleForFree: forPlus ? "http://schema.org/False" : "http://schema.org/True",
            name: name,
            provider: {
                "@type": "Organization",
                name: "Unacademy"
            },
            "@type": "Course",
            description: description
        }
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (subListing);


/***/ }),

/***/ 23018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hm": function() { return /* binding */ goBack; },
/* harmony export */   "Ox": function() { return /* binding */ getDoubtSolutionsHomeTags; },
/* harmony export */   "ZM": function() { return /* binding */ getFreeCourseTags; },
/* harmony export */   "fu": function() { return /* binding */ getCatalogueQuetionsHomeTag; },
/* harmony export */   "ll": function() { return /* binding */ getClass; },
/* harmony export */   "rs": function() { return /* binding */ getCatalogueDetailsHomeTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _models_Topology__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34482);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56046);
/* harmony import */ var _api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61059);
/* harmony import */ var _textHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31309);

/* eslint-disable max-lines */ 



var getClass = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isGTP = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    var _programme = item.programme, programme = _programme === void 0 ? {} : _programme;
    var goal = programme.goal, courseName = programme.name;
    if (!goal) return [];
    if (item.isSpecial || ((ref = item.programme) === null || ref === void 0 ? void 0 : ref.isSpecial)) {
        var tags = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
            }
        ];
        tags.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : {
            title: "Free classes & tests",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLink */ .Lb)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLinkHref */ .EN)()
        });
        return tags;
    }
    var tags1 = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (!isGTP) {
        tags1.push({
            title: courseName,
            as: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLink */ .Rg)(programme),
            href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLinkPath */ .bc)(programme)
        });
    }
    return tags1;
};
var getDoubtSolutionsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getCatalogueQuetionsHomeTag = function(goal, ctlgData) {
    var // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var ctlgSlug = ctlgData.ctlgSlug, ctlgUID = ctlgData.ctlgUID, ctlgTitle = ctlgData.ctlgTitle;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubt Solving",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        },
        {
            title: ctlgTitle,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/").concat(ctlgSlug, "/").concat(ctlgUID),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/[catalogSlug]/[catalogUID]")
        }
    ];
};
var getCatalogueDetailsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubts & solutions",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        }
    ];
};
var getPlusTopicsTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getPlatformBatchTopicsTags = function(goal) {
    if (!goal) return [];
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getBatchTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isStoreRoute = arguments.length > 2 ? arguments[2] : void 0;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return isStoreRoute ? [
        {
            title: goal.name,
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        },
        {
            title: "Batches",
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        }
    ] : [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: title,
            as: as,
            href: href
        },
        {
            title: "Batches",
            as: "".concat(as, "/batches"),
            href: "".concat(href, "/batches")
        }
    ];
};
var getYoutubeLessonTags = function(goal, data) {
    if (!goal) return;
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: goal.name
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: data.playlistName
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeLessonLink */ ._Y)(data))
    ];
};
var getYoutubeCourseTags = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal)),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)())
        },
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)({
            goalUID: goal.uid
        }))
    ];
};
var getGoalAndFreeTagsOfFreeTopic = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Free courses",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/free-platform"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/free-platform")
        }
    ];
};
var getGoalTopicsTitle = function(goal, isGTP) {
    if (goal.isNoTestGoal) return "Key concepts";
    if (isGTP) return "Video lessons";
    return "Syllabus";
};
var getTopics = function(goal) {
    var isGTP = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!goal) return;
    return [
        {
            // eslint-disable-next-line no-nested-ternary
            title: getGoalTopicsTitle(goal, isGTP),
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/topics"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/topics")
        }
    ];
};
var getTopologyTags = function(topology, goal) {
    if (!topology || !goal) return;
    return [
        {
            title: topology.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topology, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLinkHref */ .BR)()
        }
    ];
};
var getEducatorTag = function(author, educatorUsername) {
    if (!author) return;
    return [
        {
            title: (0,_api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFullName */ .P)(author.firstName, author.lastName),
            as: "/@".concat(educatorUsername),
            href: "/[authorID]"
        }
    ];
};
var getCourseTags = function(goal, topicGroup) {
    var isOfflineSubscription = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var Tags = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (topicGroup) {
        Tags.push({
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        }, {
            title: topicGroup.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        });
    }
    return Tags;
};
var getFreeCourseTags = function(goal, topologies) {
    var ref;
    if (!(goal === null || goal === void 0 ? void 0 : goal.uid)) return [];
    var ref1 = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal), href = ref1.href, as = ref1.as;
    var Tags = [
        {
            title: goal.name,
            href: href,
            as: as
        },
        {
            title: "Free courses",
            href: href,
            as: as
        }
    ];
    if (topologies === null || topologies === void 0 ? void 0 : (ref = topologies.parent) === null || ref === void 0 ? void 0 : ref.parent) {
        Tags.push({
            title: topologies.parent.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID] "
        });
        Tags.push({
            title: topologies.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_3__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.name, "-"), "/").concat(topologies.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID] "
        });
    }
    return Tags;
};
var getTestSeriesTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Test series",
            href: "/goal/[goalSlug]/[goalUID]/test-series",
            as: "/goal/".concat(goal.slug, "/").concat(goal.uid, "/test-series")
        }
    ];
};
var getPlatformSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isOfflineSubscription = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    var seeAllLinks = null;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free classes & tests"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    return [
        {
            title: goal.name
        },
        {
            title: title
        },
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isGTP = arguments.length > 5 ? arguments[5] : void 0, isOfflineSubscription = arguments.length > 6 ? arguments[6] : void 0;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var seeAllLinks = null;
    if (seeAllType === "enrolledBatches") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getPannerLink */ .vx)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            }
        ];
        seeAllLinks.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Free classes & tests"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal)));
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                },
                {
                    title: "Browse",
                    as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/browse"),
                    href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal), "/browse")
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || "",
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "enrolledCourses") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            {
                title: "Enrolled",
                href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/enrolled"),
                as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/enrolled")
            }
        ];
        return seeAllLinks;
    }
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: title
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSavedTag = function(goal) {
    if (!goal) return [];
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            title: "Saved"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfSaved */ .vX)(goal))
    ];
};
var goBack = function() {
    return window.history.back();
};
var getDriveTags = function(ancestors) {
    if (!ancestors || !Array.isArray(ancestors)) return [];
    return ancestors.map(function(item) {
        var isRoot = (item === null || item === void 0 ? void 0 : item.name) === "root";
        return {
            title: isRoot ? "Cloud" : item === null || item === void 0 ? void 0 : item.name,
            as: isRoot ? "/educator/drive" : "/educator/drive/folder/".concat(item === null || item === void 0 ? void 0 : item.uid),
            href: isRoot ? "/educator/drive" : "/educator/drive/folder/[itemUID]"
        };
    });
};
var getFreeLiveClassesTags = function(goal) {
    if (!goal) return;
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: "Free live classes",
            as: "".concat(as, "/classes"),
            href: "".concat(href, "/classes")
        }
    ];
};
var breadcrumbs = {
    getClass: getClass,
    goBack: goBack,
    getPlusTopicsTags: getPlusTopicsTags,
    getTopologyTags: getTopologyTags,
    getTopics: getTopics,
    getCourseTags: getCourseTags,
    getTestSeriesTags: getTestSeriesTags,
    getSeeAllTags: getSeeAllTags,
    getFreeCourseTags: getFreeCourseTags,
    getGoalAndFreeTagsOfFreeTopic: getGoalAndFreeTagsOfFreeTopic,
    getBatchTags: getBatchTags,
    getSavedTag: getSavedTag,
    getDriveTags: getDriveTags,
    getDoubtSolutionsHomeTags: getDoubtSolutionsHomeTags,
    getCatalogueQuetionsHomeTag: getCatalogueQuetionsHomeTag,
    getCatalogueDetailsHomeTags: getCatalogueDetailsHomeTags,
    getPlatformSeeAllTags: getPlatformSeeAllTags,
    getPlatformBatchTopicsTags: getPlatformBatchTopicsTags,
    getEducatorTag: getEducatorTag,
    getYoutubeLessonTags: getYoutubeLessonTags,
    getYoutubeCourseTags: getYoutubeCourseTags,
    getFreeLiveClassesTags: getFreeLiveClassesTags
};
/* harmony default export */ __webpack_exports__["ZP"] = (breadcrumbs);


/***/ }),

/***/ 70507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getCustomPageDetails; }
/* harmony export */ });
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17579);
/* eslint-disable import/prefer-default-export */ 
var getCustomPageDetails = function(goalName, goalTitle, pageName) {
    var pageCustomDetails;
    switch(pageName){
        case _constants_segment__WEBPACK_IMPORTED_MODULE_0__/* .ALL_TEST_SERIES */ .BRR:
            pageCustomDetails = {
                title: "Tests for ".concat(goalName),
                testWithTitleCombats: "Test series for ".concat(goalName),
                description: "Attempt ".concat(goalName, " free mock tests & test series curated by our educators to boost your preparation."),
                testSeriesBlockTitle: "".concat(goalName, " Test series"),
                testSeriesBlockDescription: "Evaluate your exam preparation with test series for ".concat(goalTitle),
                combatsBlockTitle: "".concat(goalName, " combats"),
                combatsBlockDescription: "Compete live with your peers to earn scholarships"
            };
            break;
        case _constants_segment__WEBPACK_IMPORTED_MODULE_0__/* .FREE_CLASSES_AND_TESTS */ .a_Z:
            pageCustomDetails = {
                title: "Free classes for ".concat(goalName),
                description: "Watch free online coaching classes for ".concat(goalName, " by our best educators. You can watch free recorded and live classes."),
                CUSTOM_FEED: {
                    live_now: {
                        label: "Free live classes",
                        description: "Interact with educators in live classes for free"
                    },
                    trending: {
                        label: "Trending classes",
                        description: "Watch popular classes for ".concat(goalName)
                    },
                    popular_subjects: {
                        label: "Popular subjects for ".concat(goalName, " preparation"),
                        description: "Browse subject-wise free classes with full syllabus coverage"
                    },
                    upcoming: {
                        label: "Upcoming free classes",
                        description: "Get notified for Upcoming ".concat(goalName, " online classes")
                    },
                    educators: {
                        label: "Popular educators in ".concat(goalName),
                        description: "Watch online classes from our popular educators for free."
                    }
                }
            };
            break;
        default:
            pageCustomDetails = {};
    }
    return pageCustomDetails;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [53662,35303,82492,52420,86924,96523,25675,61608,41664,63953,92781,29238,86985,13494,23689,80742,9720,46571,94336,16050,4392,95965,72047,41566,48392,9453,55033,30038,94142,52574,27271,49774,92888,40179], function() { return __webpack_exec__(10428); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);